import React from "react";
import { Badge } from "@/components/ui/badge";
import type { FAQ } from "@/types/faq";

interface FaqItemProps {
  faq: FAQ;
}

export const FaqItem: React.FC<FaqItemProps> = ({ faq }) => {
  return (
    <div className="flex h-36 w-64 flex-col justify-between gap-3 rounded-xl border border-zinc-200 bg-zinc-100 p-4">
      <div className="flex items-start justify-between gap-2">
        {faq.category?.name ? (
          <Badge
            variant="secondary"
            className="bg-zinc-800 px-2 py-0 text-[10px] text-white"
          >
            {faq.category.name}
          </Badge>
        ) : null}
      </div>

      <div className="flex flex-col gap-1">
        <span className="line-clamp-2 text-sm font-medium">{faq.question}</span>
        <span className="line-clamp-3 text-xs text-zinc-500">{faq.answer}</span>
      </div>
    </div>
  );
};
